module.exports = __webpack_public_path__ + "static/media/investor-homepage.b5b63804.jpg";